/*
 *   File : text-input.js
 *   Author : https://evoqins.com
 *   Description : Text input component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { memo, useState } from 'react';

//custom style
import style from "../../Style/Components/input.module.scss";

const CustomTextArea = (props) => {

    const [isInputFocused, setIsInputFocused] = useState(false);

    // handle focus 
    const _handleFocus = () => {
        setIsInputFocused(true);
    };

    const _handleBlur = () => {
        setIsInputFocused(false);
    };

    //input handle change
    const _handleChange = (e) => {
        let value = e.target.value;

        if (props.type === 'number') {
            const numericOnly = /^[0-9]*$/;
            if (numericOnly.test(value)) {
                props.handleChange(value);
            }
        } else {
            // Allow only letters and spaces (if you want this validation for text)
            const validate_name = /^[A-Za-z ]*$/;
            if (validate_name.test(value)) {
                props.handleChange(value);
            }
        }
    };

    // handle enter key press
    const keyPress = (e) => {
        if (e.keyCode === 13 && typeof props.onKeyPress === 'function') {
            props.onKeyPress();
        }
    };

    const _handleKeyDown = (e) => {
        if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
            e.preventDefault();
        }

        if (props.type === 'number') {
            const allowedKeys = [
                'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete',
            ];
            const isDigit = e.key >= '0' && e.key <= '9';

            // Allow Ctrl/Cmd + A, C, V, X
            const isCtrlCmdCombo = (e.ctrlKey || e.metaKey) &&
                ['a', 'c', 'v', 'x'].includes(e.key.toLowerCase());

            if (!isDigit && !allowedKeys.includes(e.key) && !isCtrlCmdCombo) {
                e.preventDefault();
            }
        }
    };


    return (
        <div className={`${style.e_input_wrapper} text-start`}>
            {props.label &&
                <label className={`${style.e_label} pb-2`}>
                    {props.label}
                    {props.required &&
                        <span className='color-carmine-pink'>*</span>
                    }
                </label>
            }

            <div className='position-relative'>
                <div className={` ${isInputFocused ? `${style.e_active} ` : `${style.e_inactive} `} `}>
                    <textarea id={props.id}
                        ref={props.ref}
                        value={props.value}
                        defaultValue={props.defaultValue}
                        maxLength={props.maxLength}
                        tabIndex={props.tabIndex}
                        type={props.type}
                        rows={4}
                        required={props.required}
                        readOnly={props.readOnly}
                        autoFocus={props.autoFocus}
                        placeholder={props.placeholder}
                        className={`${style.e_input} w-100 border-0 p-3`}
                        onWheel={() => document.activeElement.blur()}
                        onFocus={_handleFocus}
                        onBlur={_handleBlur}
                        onChange={_handleChange}
                        onKeyDown={(e) => {
                            keyPress(e);
                            _handleKeyDown(e);
                        }}
                        onClick={props.onClick} />

                </div>

                {props.error &&
                    <p className={style.e_error_message}>
                        {props.error}
                    </p>
                }
            </div>
        </div >
    )
}

CustomTextArea.defaultProps = {
    onKeyPress: () => { },
    className: null,
    error: "",
    value: "",
}

export default memo(CustomTextArea);